<template>
  <hypto-popup :title="'Setup 2 Factor Authentication'" :footer="false">
    <template v-slot:body>
      <ul v-if="setup">
        <li>Download the Google Authenticator app from the Google Play store or Apple app store</li>
        <li>Scan the QR code or input the setup key from this screen</li>
        <li>Once setup, please input the OTP from the Google Authenticator app here to login to your Hypto account</li>
      </ul>
      <ul v-else>
        <li>Download the Google Authenticator app from the Google Play Store or Apple App Store</li>
        <li>Once 2FA is enabled/reset, you will have to login again to the Hypto dashboard</li>
        <li>Scan the QR code or input the setup key that is displayed upon login to link the 2FA to your mobile device</li>
        <li>Once linked, please input the OTP from the Google Authenticator app here to login to your Hypto account</li>
      </ul>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'

export default {
  name: 'Setup2FA',
  components: { HyptoPopup },
  props: {
    setup: Boolean
  }
}
</script>

<style scoped lang="scss">
  ul {
    text-align: left;

    li {
      font-size: 14px;
      margin: 5px 0;
    }
  }
</style>
